import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=db5a8f76&scoped=true&"
import script from "./TagView.vue?vue&type=script&lang=js&"
export * from "./TagView.vue?vue&type=script&lang=js&"
import style0 from "./TagView.vue?vue&type=style&index=0&id=db5a8f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5a8f76",
  null
  
)

export default component.exports